var AnalyticsEvents;
(function (AnalyticsEvents) {
    AnalyticsEvents["BANNER_VIEW"] = "banner_view";
    AnalyticsEvents["BANNER_CTA_CLICK"] = "banner_cta_click";
    AnalyticsEvents["CHATBOT_FAVORITE"] = "chatbot_favorite";
    AnalyticsEvents["LOREBOOK_FAVORITE"] = "lorebook_favorite";
    AnalyticsEvents["SWITCH_NSFW"] = "switch_nsfw";
    AnalyticsEvents["SWITCH_TTS_NARRATION"] = "switch_tts_narration";
    AnalyticsEvents["CHOOSE_CHAT_LANGUAGE"] = "choose_chat_language";
    AnalyticsEvents["VIEW_PAGE"] = "view_page";
    AnalyticsEvents["CHATBOT_DESCRIPTION"] = "chatbot_description";
    AnalyticsEvents["CHATBOT_SELECT"] = "chatbot_select";
    AnalyticsEvents["CHATBOT_SHARE"] = "chatbot_share";
    AnalyticsEvents["SOCIAL_MEDIA_CLICK"] = "social_media_click";
    AnalyticsEvents["SUBSCRIPTION_PLAN_VIEW"] = "subscription_plan_view";
    AnalyticsEvents["SUBSCRIPTION_PLAN_SELECT"] = "subscription_plan_select";
    AnalyticsEvents["SUBSCRIPTION_MONEY_VALUE"] = "subscription_money_value";
    AnalyticsEvents["SUBSCRIPTION_CHECKOUT_START"] = "subscription_checkout_start";
    AnalyticsEvents["CHECKOUT_PURCHASE_COMPLETE"] = "checkout_purchase_complete";
    AnalyticsEvents["SIDENAV_NAVIGATION"] = "sidenav_navigation";
    AnalyticsEvents["SIGNIN_CLICK"] = "signin_click";
    AnalyticsEvents["SIGNOUT_CLICK"] = "signout_click";
    AnalyticsEvents["PERSONA_CREATE"] = "persona_create";
    AnalyticsEvents["PERSONA_DEFAULT"] = "persona_default";
    AnalyticsEvents["CHECKOUT_PROCEED"] = "checkout_proceed";
    AnalyticsEvents["CHECKOUT_COUPON_APPLY"] = "checkout_coupon_apply";
    AnalyticsEvents["CHECKOUT_PAYMENT_METHOD_SELECT"] = "checkout_payment_method_select";
    AnalyticsEvents["CHECKOUT_EXIT_ABANDON"] = "checkout_exit_abandon";
    AnalyticsEvents["PURCHASE"] = "purchase";
    AnalyticsEvents["LOGIN"] = "login";
    AnalyticsEvents["SIGN_UP"] = "sign_up";
    AnalyticsEvents["DISCOVERY_TAG_CLOUD_TAG_SELECT"] = "discovery_tag_cloud_tag_select";
})(AnalyticsEvents || (AnalyticsEvents = {}));
// eslint-disable-next-line import/prefer-default-export -- named export matches package barrel
export { AnalyticsEvents };
